import { getStore } from '../store/store';

export default function getUnreadConversationsCount(): number {
    return getStore().unreadConversationsCount;
}
